import { render, staticRenderFns } from "./result_school.vue?vue&type=template&id=01d05002&scoped=true"
import script from "./result_school.vue?vue&type=script&lang=js"
export * from "./result_school.vue?vue&type=script&lang=js"
import style0 from "./result_school.vue?vue&type=style&index=0&id=01d05002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d05002",
  null
  
)

export default component.exports